module.exports = __webpack_public_path__ + "static/media/ic_head7.4e79ee20.png";